import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminHome from "@/pages/admin/AdminHome";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminClients from "@/pages/admin/AdminClients";
import AdminPackages from "@/pages/admin/AdminPackages";
import AdminAllOrders from "@/pages/admin/AdminAllOrders";
import AdminArchives from "@/pages/admin/AdminArchives";
import AdminContact from "@/pages/admin/AdminContact";
import ClientLayout from "@/pages/client/ClientLayout";
import ClientHome from "@/pages/client/ClientHome";
import ClientOrder from "@/pages/client/ClientOrder";
import ClientAccount from "@/pages/client/ClientAccount";
import ClientArchives from "@/pages/client/ClientArchives";
import ClientContact from "@/pages/client/ClientContact";

const Loader = () => (
  <div className="flex min-h-screen items-center justify-center bg-white">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-black border-t-transparent" />
  </div>
);

function Guard({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/espace"} replace />;
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/espace"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <Toaster position="top-right" toastOptions={{ style: { borderRadius: "4px" } }} />
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/admin" element={<Guard role="admin"><AdminLayout /></Guard>}>
              <Route index element={<AdminHome />} />
              <Route path="commandes-en-cours" element={<AdminOrders />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="packages" element={<AdminPackages />} />
              <Route path="commandes" element={<AdminAllOrders />} />
              <Route path="archives" element={<AdminArchives />} />
              <Route path="contact" element={<AdminContact />} />
            </Route>

            <Route path="/espace" element={<Guard role="client"><ClientLayout /></Guard>}>
              <Route index element={<ClientHome />} />
              <Route path="commander" element={<ClientOrder />} />
              <Route path="compte" element={<ClientAccount />} />
              <Route path="archives" element={<ClientArchives />} />
              <Route path="contact" element={<ClientContact />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
